<template>
	<main>
		<div class="container">
			<div class="scroll" v-if="!loading">
				<h1 class="page-title">{{pageData.title}}</h1>
				<component :is="component.type" :data="component" v-for="(component, index) in widgets" :key="index"></component>
				<template>
					<calendar :id="selected"/>
				</template>
			</div>
			<div class="loading" v-if="loading"><img src="/img/loading.gif"></div>
		</div>
	</main>
</template>

<script>
//importing widgets
import textcontent from '../../components/widgets/text'
import calendar from '../../components/track/calendar'

export default {
	components: {
		textcontent,
		calendar
	},
	props:['id'],
	name: 'Calendar',
	watch:{ // watching for route change
		$route (to, from){
			this.$nextTick(() => {
				this.getPagedata()
			})
		}
	},
	computed: { // setting list of widgets
		widgets() {
			return this.components
		}
	},
	data() {
		return {
			ps:null,
			pageData:[],
			components:[],
			comp:[],
			selected: this.$route.params.id,
			lang: localStorage.lang ? localStorage.lang  : 'en',
			loading:true
		}
	},
	mounted: function() {
		this.getPagedata()
	},
	methods: {
		getPagedata: function() { // getting current page data
			this.pageData = []
			this.components = []
			this.loading = true
			this.axios.get(process.env.VUE_APP_URL+'subsection/track', {params:{name:'track', language:this.lang}})
			.then(response => {
				this.pageData = response.data
				this.prepareComponents()
			})
			// .catch(error => {
			//   console.log(error)
			//   this.$router.push({name:'prevent'})
			// })
		},
		prepareComponents: function(){ // making widgets array
			if(this.pageData.text_contents && this.pageData.text_contents.length > 0) {
				this.pageData.text_contents.map(a => {
					a.type = 'textcontent'
					this.components.push(a)
				})
			}
			this.$nextTick(() => {
					this.sortComponents()
			})
		},
		sortComponents: function(){ // sorting widgets by index prop
			function compare(a,b) {
				if (a.index < b.index)
					return -1;
				if (a.index > b.index)
					return 1;
				return 0;
			}

			this.components = this.components.sort(compare)

			this.loading = false
			this.$nextTick(() => {
					this.perfectScrollInit()
			})
		},
		perfectScrollInit: function() { // perfect scroll init goes after dom update
			var container = document.querySelector('.scroll')
			if(!this.ps && container) {
				this.ps = new PerfectScrollbar(container)
			} else if(container) {
				this.ps.destroy()
				this.ps = null
				this.ps = new PerfectScrollbar(container)
				container.scrollTop = 0
			}
		}
	}
}

</script>